import { get } from "lodash";
import mediator from "@tvg/mediator";
import type { Race } from "@tvg/ts-types/Race";
import {
  getRacePromos,
  isUserOptedInPromo
} from "@urp/lib-racetracks/src/utils/races";
import type { UserOptedInPromos } from "@tvg/ts-types/User";
import {
  SpecialWagerTypesNamesEnum,
  SpecialWagerTypesAbbreviationEnum
} from "@tvg/ts-types/SpecialWager";
import { replaceCAPIVariables } from "@tvg/utils/capiUtils";
import { getSpecialWagerTypeName } from "@urp/lib-racetracks/src/utils/analytics";
import { SpecialWagerTrack } from "./types";

export const getSpecialPickLabel = (track: SpecialWagerTrack) => {
  const numberOfRaces = get(track, "numberOfRaces", "");
  return numberOfRaces === 2 ? "Special DD" : `Special P${numberOfRaces}`;
};

export const sendAnalyticsEvt = (
  race: Race,
  url: string,
  section: string,
  optedInPromos: UserOptedInPromos,
  specialWagerType: SpecialWagerTypesAbbreviationEnum,
  position: number
) => {
  const availableRacePromos = getRacePromos(race);
  const isOptedIn = isUserOptedInPromo(optedInPromos, availableRacePromos);
  const specialWagerTypeName = getSpecialWagerTypeName(specialWagerType);

  mediator.base.dispatch({
    type: "RACE_CELL_CLICKED",
    payload: {
      section,
      linkUrl: url,
      race,
      trackName: race.track.name,
      module: "special_wagers",
      isFDTV: race.video.onTvg || race.video.onTvg2,
      raceNumber: race.raceNumber,
      promoLevel: "track_level",
      promoOptedIn: isOptedIn.toString(),
      trackCountry: race.track.location?.country,
      specialWagerType: specialWagerTypeName,
      position
    }
  });
};

export const getSpecialWagerTooltip = (
  tooltipDescription: Record<SpecialWagerTypesNamesEnum, string>,
  specialWagerTypeName: SpecialWagerTypesNamesEnum,
  variables?: Record<string, unknown>
) => {
  const isSpecialPick =
    specialWagerTypeName === SpecialWagerTypesNamesEnum.NON_CONSECUTIVE_PICK;

  return isSpecialPick
    ? replaceCAPIVariables(tooltipDescription.NONCONSECUTIVEPICK, variables)
    : tooltipDescription[specialWagerTypeName];
};
